import { filter } from "lodash";
import { useSession } from "next-auth/react";
import { useQuery } from "react-query";
import { getyMyEntry } from "../api/entries";
import ScoreSummaryRankScore from "./ScoreSummaryRankScore";
import ScoreSummaryPlayers from "./ScoreSummaryPlayers";
import ScoreSummaryPools from "./ScoreSummaryPools";
import React from "react";

const ScoreSummary = (props) => {
  const globalPool = filter(props.pools, (o) => o.type === "GLOBAL")[0];
  const position = globalPool?.position.rank;
  const score = globalPool?.position.score;
  const { data: session }: any = useSession();
  const accessToken = session?.accessToken;

  const {
    isLoading,
    error,
    data: entryData,
  } = useQuery<any, Error, any>(
    "myEntry",
    () => {
      return getyMyEntry(accessToken);
    },
    {
      enabled: !!accessToken,
    },
  );

  if (entryData && entryData.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 mt-2 md:grid-cols-4 gap-2">
      <div className="col-span-2">
        <React.Fragment>
          <div className="mb-2">
            <ScoreSummaryRankScore rank={position} score={score} />
          </div>
          <ScoreSummaryPools pools={props.pools} />
        </React.Fragment>
      </div>
      <div className="col-span-2">
        {<ScoreSummaryPlayers players={entryData} />}
      </div>
    </div>
  );
};
export default ScoreSummary;
